module.exports = __webpack_public_path__ + "img/service4.02af2f95.svg";